/**
 * @generated SignedSource<<302392999a41e578ef714fbe3c31fd06>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedBuyerProtectionBox_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedBuyerProtectionGuarantee_user" | "PdpSharedBuyerProtection_user">;
  readonly " $fragmentType": "PdpSharedBuyerProtectionBox_user";
};
export type PdpSharedBuyerProtectionBox_user$key = {
  readonly " $data"?: PdpSharedBuyerProtectionBox_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedBuyerProtectionBox_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedBuyerProtectionBox_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBuyerProtectionGuarantee_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBuyerProtection_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "8a8e59dcca8e0b4da2486b37a124dae3";

export default node;
